import { makeObservable, observable } from 'mobx';

import { assignModel } from '@/common/helpers/assignModel';
import { DriveItemPreview } from '@/drive/entities/DriveItem/DriveItemPreview';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { PinnedItem } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { BaseProductType } from '@/product/constants/productTypes';
import { ProductId } from '@/product/entity/Product';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProductDataAccess } from '@/security/types/DataAccess';

import { BaseDriveItem, DriveItemType } from './DriveItem.types';
import { ProductItem } from './ProductItem';

export class SpectrumItemModel {
  id!: DriveItemId;
  title!: string;
  type!: DriveItemType.Spectrum;
  description?: string;
  preview?: Nullable<DriveItemPreview>;
  canEdit!: boolean;
  canManageAccess!: boolean;
  productId?: ProductId;
  productType?: BaseProductType;
  hasCBR!: boolean;
  access?: Nullable<GlobalAccessLevel>;
  dataAccess?: Nullable<ProductDataAccess>;
}

export class SpectrumItem extends BaseDriveItem {
  productId?: ProductId;
  productType?: BaseProductType;
  hasCBR!: boolean;
  access?: Nullable<GlobalAccessLevel>;
  dataAccess?: Nullable<ProductDataAccess>;

  constructor(model: SpectrumItemModel) {
    super();

    makeObservable(this, {
      productId: observable,
      productType: observable,
      hasCBR: observable,
      access: observable,
      dataAccess: observable,
    });

    assignModel<SpectrumItemModel>(this as unknown as SpectrumItemModel, model);
  }

  getLinkData() {
    return this.toProduct().getLinkData();
  }

  override canBeShared(): boolean {
    return !!this.productId;
  }

  override toPinnedItem(): Nullable<PinnedItem> {
    return this.toProduct().toPinnedItem();
  }

  toProduct(): ProductItem {
    return new ProductItem({
      id: this.id,
      title: this.title,
      type: DriveItemType.Product,
      description: this.description,
      preview: this.preview,
      productId: this.productId,
      productType: this.productType,
      hasCBR: this.hasCBR,
      canEdit: this.canEdit,
      canManageAccess: this.canManageAccess,
      access: this.access,
      dataAccess: this.dataAccess,
    });
  }
}
